import React from "react";
import { Provider } from "react-redux";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AppRouter } from "./routes/AppRouter";

import { createTheme, ThemeProvider } from "@mui/material/styles";
import { store } from "./store/store";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "dayjs/locale/es";
import InstallPWAButton from "./components/pwa/InstallPWAButton";
import { perfMark } from "./utils/perf-tracker";
import { ClearCacheOnUserChange } from "./components/auth/ClearCacheOnUserChange";

// TanStack Query client - configured once at app level
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
    },
  },
});

function App() {
  perfMark("app-component-mount");
  const theme = createTheme({
    typography: {
      // Tell MUI what's the font-size on the html element is.
      htmlFontSize: 10,
    },
  });
  return (
    <QueryClientProvider client={queryClient}>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
        <Provider store={store}>
          <ClearCacheOnUserChange />
          <ThemeProvider theme={theme}>
            <AppRouter />
            <InstallPWAButton />
          </ThemeProvider>
        </Provider>
      </LocalizationProvider>
    </QueryClientProvider>
  );
}

export default App;
